import React, { useEffect, useRef, useState } from "react";
import { ReactComponent as BentoMenu } from "../../images/bento_menu.svg";
import { ReactComponent as EditIcon } from "../../images/edit.svg";
import { ReactComponent as DeleteIcon } from "../../images/delete.svg";
import moment from "moment";

const VoucherCard = ({
  voucher,
  showBentoMenu,
  customerOptions,
  RedemptionsRule,
  vouchers,
  type,
  HandleEdit,
  HandleDelete,
  pagePermission
}) => {
  console.log("TYPE", type)
  const GetCustomerOption = (value) => {
    if (customerOptions !== undefined) {
      const temp = customerOptions.filter((it) => it.value == value).pop();
      return temp?.label !== undefined ? temp?.label : "";
    } else {
      return "";
    }
  };
  const GetRedemptionOption = (value) => {
    if (RedemptionsRule !== undefined) {
      const temp = RedemptionsRule.filter((it) => it.value == value).pop();
      return temp?.label !== undefined ? temp?.label : "";
    } else {
      return "";
    }
  };
  const [isBentoMenuOpen, setIsBentoMenuOpen] = useState(false);
  const bentoMenuRef = useRef(null);

  useEffect(() => {
    const handleDocumentClick = (e) => {
      if (
        isBentoMenuOpen &&
        bentoMenuRef.current &&
        !bentoMenuRef.current.contains(e.target)
      ) {
        setIsBentoMenuOpen(false);
      }
    };

    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, [isBentoMenuOpen]);

  return (
    <div
      className={`voucher-list-card ${type !== undefined
        ? `voucher-${type}`
        : voucher?.active
          ? "voucher-inactive"
          : vouchers !== undefined
            ? vouchers[voucher?.flooring_product]?.isDisabled
              ? "voucher-inactive"
              : localStorage.getItem(`${voucher?.flooring_product}`) !== null ? "voucher-active" : "voucher-pending"
            : "voucher-pending"
        }`}
    >
      <div className="vertical-text">
        {/**
         * type === "inactive" ? "In-Active" : vouchers[voucher?.flooring_product]?.isDisabled ? "In-Active" 
         */}
        <p>
          {type !== undefined ?
            voucher?.customer_type?.label !== undefined
              ? type === "inactive" ? "In-Active" : voucher?.customer_type?.label
              : GetCustomerOption(voucher.customer_type)
            : vouchers[voucher?.flooring_product]?.isDisabled ? "In-Active"
              : voucher?.customer_type?.label !== undefined
                ? voucher?.customer_type?.label
                : GetCustomerOption(voucher.customer_type)}
        </p>
      </div>
      <div className="voucher-list-card-info">
        <div className="flex items-start justify-between">
          <h3>{`${voucher?.flooring_product?.label !== undefined
            ? voucher?.flooring_product?.label === "BODYONLY" ? "BODY ONLY" : voucher?.flooring_product?.label
            : voucher?.flooring_product === "BODYONLY" ? "BODY ONLY" : voucher?.flooring_product
            } Voucher`}</h3>
          {showBentoMenu && (
            <div className="bento-menu-block" ref={bentoMenuRef}>
              <span
                className="bento-menu"
                onClick={() => setIsBentoMenuOpen(!isBentoMenuOpen)}
              >
                <BentoMenu />
              </span>
              {isBentoMenuOpen ? (

                <div className="bento-menu-dropdown">
                  {pagePermission?.update_permission == 1 && (
                    <button className="text-btn" onClick={() => {
                      HandleEdit(voucher?.id, voucher?.flooring_product?.label.trim());
                    }}>
                      <span>
                        <EditIcon />
                      </span>
                      Edit Details
                    </button>
                  )}
                  {pagePermission?.delete_permission == 1 && (
                    <button className="text-btn text-btn-delete" onClick={() => {
                      HandleDelete(voucher?.id, voucher)
                    }}>
                      <span>
                        <DeleteIcon />
                      </span>
                      Delete
                    </button>
                  )}
                </div>
              ) : null}
            </div>
          )}
        </div>
        <div className="voucher-list-row">
          <div>
            <h6>Interest Rate</h6>
            <p>
              {
                voucher?.interest_rate !== undefined && voucher?.interest_rate !== ""
                  ? vouchers !== undefined
                    ? vouchers[voucher?.flooring_product]?.interest : `${voucher?.interest_rate}%`
                  : vouchers !== undefined
                    ? vouchers[voucher?.flooring_product]?.interest !== ""
                      ? `${vouchers[voucher?.flooring_product]?.interest}%` : "N/A" : "N/A"}
            </p>
          </div>
          <div>
            <h6>Valid From</h6>
            <p>{voucher.start_period == "" ? "N/A" : !isNaN(voucher.start_period) ? moment(voucher.start_period).format("DD-MM-YYYY") : voucher.start_period}</p>
          </div>
          <div>
            <h6>Valid Till</h6>
            <p>{voucher.end_period == "" ? voucher.start_period == "" ? "N/A" : "Further Notice" : !isNaN(voucher.end_period) ? moment(voucher.end_period).format("DD-MM-YYYY") : voucher.end_period}</p>
          </div>
        </div>
        <div className="voucher-list-row">
          <div>
            <h6>Eligible Amt From</h6>
            <p>{voucher.amount_from == "" ? "N/A" : `$${voucher.amount_from}`}</p>
          </div>
          <div>
            <h6>Eligible Amt to</h6>
            <p>{voucher.amount_to == "" ? "N/A" : `$${voucher.amount_to}`}</p>
          </div>
          <div />
        </div>
        <div className="voucher-list-row">
          <div>
            {console.log("voucher_qty_type", voucher?.voucher_qty_type)}
            <h6>Voucher Quantity</h6>
            {voucher?.voucher_qty_type == "0" ? (
              <p>Unlimited  </p>
            ) : (
              <p>
                {voucher?.voucher_qty_type?.value !== undefined && voucher?.voucher_qty_type?.value == 0 ? `${voucher?.voucher_qty_type?.label}` :
                  voucher?.redeemed_qty !== undefined ? `${voucher?.redeemed_qty} /` : `${voucher?.qty}/`}{" "}
                <span>{voucher?.qty !== "" ? `${voucher?.qty == 0 ? "" : voucher?.qty}` : "N/A"}</span>
              </p>
            )}
          </div>
          <div>
            <h6>Redemption Rule</h6>
            <p>
              {voucher.redemption_rule?.label !== undefined
                ? voucher?.redemption_rule?.label
                : voucher?.redemption_rule !== ""
                  ? GetRedemptionOption(voucher.redemption_rule)
                  : "N/A"}
            </p>
          </div>
          <div />
        </div>
      </div>
      <div className="repeating-circle" />
    </div>
  );
};

export default VoucherCard;
